import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-inline-spinner',
    template: '<div class="spinner"></div>',
    styleUrl: './inline-spinner.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class InlineSpinnerComponent {}
